import React, { useState, useEffect } from "react";
import { List, ListItem, ListItemText, Typography, Paper, CircularProgress } from "@mui/material";
import axiosService from "shared/helpers/axios";
import { useUser } from "shared/helpers/axios";
// import Layout from 'components/layout/_Layout'

function AllSuggestions() {
  const { user } = useUser();
  const [suggestions, setSuggestions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user.is_superuser) return;

    axiosService
      .get("/suggestions/")
      .then((response) => {
        setSuggestions(response.data);
        setLoading(false);
      })
      .catch((error) => console.error("Error fetching suggestions:", error));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!user.is_superuser) {
    return <Typography color="error">Access Denied: Only Superusers Can View This Page</Typography>;
  }

  return (

    // <Layout user={user}>
    <Paper sx={{ p: 2, mt: 2 }}>
      <Typography variant="h6">All Suggestions</Typography>
      {loading ? <CircularProgress /> : (
        <List>
          {suggestions.length === 0 ? (
            <Typography>No suggestions available.</Typography>
          ) : (
            suggestions.map((s) => (
              <ListItem key={s.id}>
                <ListItemText
                  primary={s.title}
                  secondary={`From: ${s.sender_name} → To: ${s.receiver_name} | ${s.body}`}
                />
              </ListItem>
            ))
          )}
        </List>
      )}
    </Paper>
    // </Layout>
  );
}

export default AllSuggestions;
